const autograderAttemptsWarning = `

Note: the continuous attempt type will allow unlimited autograder attempts upon submission regardless of your configurations. Students can start, edit, and resubmit their attempt as many times as needed until the deadline (there is no enforced duration in this configuration). Each submission runs all autograders, saves progress, and allows for continued editing rather than finalizing the attempt. End time refers to the last time a student clicked submit (not the last save).

`

export default autograderAttemptsWarning;